import DialogPreview from 'components/DialogPreview/DialogPreview'
import { Grid } from '@mui/material';
import { useEffect } from 'react';
import { FnAxios } from 'utilities/utilities';
import { SelectItem } from 'components/Input/Select/SelectItem';
import { FormProvider, useForm } from 'react-hook-form';
import { BtnConfirm } from 'components/Button/ButtonAll';
import moment from 'moment';

const DialogVersion = ({ isOpenVersion, setIsOpenVersion, nYear, option,handleSelectVersion ,isInCome}) => {


    const AxiosFn = FnAxios();

    const form = useForm({
        shouldFocusError: true,
        shouldUnregister: false,
        mode: "all",
        defaultValues: {
            nVersion: null
        }
    });

    useEffect(() => {
        if (isOpenVersion) {
            form.setValue("nVersion", null)
        }
    }, [form, isOpenVersion])

    const handleSubmitVersion = () => {
        let objParam = {
            nYear: nYear ? parseInt(moment(nYear).format('YYYY')) : null,
            nVersion: form.getValues("nVersion")
        }
        let apiGetVersion = isInCome ? `FundIncomePlan/GetVersionFundIncomePlan` : `FundExpensePlan/GetVersionFundExpensePlan`;
        AxiosFn.Get(apiGetVersion, objParam, (result) => {
            let objResult = isInCome ? result.objResult.objIncome : result.objResult;
            handleSelectVersion(objResult)
            setIsOpenVersion(false)
        });
    }

    const handleClose = () => {
        setIsOpenVersion(false)
    }

    return (
        <DialogPreview
            IsOpen={isOpenVersion}
            Title={"เวอร์ชัน"}
            sMaxWidth="sm"
            JsxDialogAction
            onClose={handleClose}
            CloseSave={false}
            Close={false}
            onCustomButton={
                <Grid
                    container
                    spacing={2}
                    justifyContent={"center"}
                >
                    <Grid item >
                        <BtnConfirm id={"BtnConfirm"} onClick={form.handleSubmit(handleSubmitVersion)} />
                    </Grid>
                </Grid>
            }
        >
            <FormProvider {...form}>
                <Grid container spacing={1} justifyContent={"center"} alignItems={"start"}>
                    <Grid item xs={12}>
                        <SelectItem
                            id={"nVersion"}
                            name={"nVersion"}
                            label={``}
                            required={true}
                            options={option}
                        />
                    </Grid>
                </Grid>
            </FormProvider>
        </DialogPreview>
    )
}

export default DialogVersion
